"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWhitelistAddress = exports.getEscrowAddress = exports.getLockerAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
const solana_contrib_1 = require("@saberhq/solana-contrib");
const web3_js_1 = require("@solana/web3.js");
const constants_1 = require("../../constants");
const getLockerAddress = (base) => {
    return (0, solana_contrib_1.getProgramAddress)([anchor_1.utils.bytes.utf8.encode("Locker"), base.toBuffer()], constants_1.TRIBECA_ADDRESSES.LockedVoter);
};
exports.getLockerAddress = getLockerAddress;
const getEscrowAddress = (locker, authority) => {
    return (0, solana_contrib_1.getProgramAddress)([
        anchor_1.utils.bytes.utf8.encode("Escrow"),
        locker.toBuffer(),
        authority.toBuffer(),
    ], constants_1.TRIBECA_ADDRESSES.LockedVoter);
};
exports.getEscrowAddress = getEscrowAddress;
const getWhitelistAddress = (locker, programId, owner) => {
    return (0, solana_contrib_1.getProgramAddress)([
        anchor_1.utils.bytes.utf8.encode("LockerWhitelistEntry"),
        locker.toBuffer(),
        programId.toBuffer(),
        owner ? owner.toBuffer() : web3_js_1.SystemProgram.programId.toBuffer(),
    ], constants_1.TRIBECA_ADDRESSES.LockedVoter);
};
exports.getWhitelistAddress = getWhitelistAddress;
//# sourceMappingURL=pdaSync.js.map